import { supabase } from './supabase';

/**
 * Send a transactional email via the send-email edge function.
 * Respects notification_toggles from system_settings.
 */
export async function sendEmail({ to, template, variables }) {
  try {
    let data, error;
    try {
      const result = await supabase?.functions?.invoke('send-email', {
        body: { to, template, variables },
      });
      data = result?.data;
      error = result?.error;
    } catch (fetchErr) {
      // Edge function not reachable (not deployed, network issue, etc.) — fail silently
      return { success: false, error: fetchErr?.message || 'Failed to fetch' };
    }
    if (error) return { success: false, error: error?.message || 'Email error' };
    return { success: true, data };
  } catch (err) {
    return { success: false, error: err?.message };
  }
}

/**
 * Fetch notification toggles from system_settings.
 * Returns an object with toggle keys as booleans.
 */
export async function getNotificationToggles() {
  try {
    const { data, error } = await supabase
      ?.from('system_settings')
      ?.select('value_json')
      ?.eq('key', 'notification_toggles')
      ?.single();
    if (error) throw error;
    return data?.value_json || {};
  } catch {
    return {};
  }
}

/**
 * Fetch a single system setting value.
 */
export async function getSystemSetting(key) {
  try {
    const { data, error } = await supabase
      ?.from('system_settings')
      ?.select('value, value_json')
      ?.eq('key', key)
      ?.single();
    if (error) throw error;
    return data?.value_json ?? data?.value ?? null;
  } catch {
    return null;
  }
}

/**
 * Send email only if the corresponding toggle is enabled.
 */
export async function sendEmailIfEnabled({ toggleKey, to, template, variables }) {
  try {
    // notify_password_reset is always active
    if (toggleKey === 'notify_password_reset') {
      return sendEmail({ to, template, variables });
    }
    const toggles = await getNotificationToggles();
    if (toggles?.[toggleKey] === false) {
      return { success: true, skipped: true };
    }
    return sendEmail({ to, template, variables });
  } catch (err) {
    return { success: false, error: err?.message };
  }
}
